import { Form, Formik } from "formik";
import { useState } from "react";
import { object, string } from "yup";
// @ts-expect-error pure js
import TextInput from "../UI/TextInput";
// @ts-expect-error pure js
import { axiosPublic } from "../../api";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import styles from "./AuthFormForgottenPassword.module.css";
import Callout from "../UI/Callout";

interface ResetPasswordValues {
  mail: string;
}

export default function AuthFormForgottenPassword() {
  const [message, setMessage] = useState("");

  async function resetPassword(values: ResetPasswordValues) {
    try {
      const res = await axiosPublic.post(`/reset-password`, {
        mail: values.mail,
      });
      if (res) {
        setMessage(
          "Un mail vient d'être envoyé, cliquez sur le lien afin de réinitialiser votre mot de passe",
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Formik
      initialValues={{ mail: "" }}
      validationSchema={object({
        mail: string()
          .email("Adresse e-mail invalide")
          .required("Adresse e-mail requise "),
      })}
      onSubmit={resetPassword}
    >
      <Form className={styles.form}>
        <TextInput
          label="Votre adresse e-mail"
          type="email"
          name="mail"
          placeholder="email@email.fr"
          marginForm=""
        />
        <FormikSubmitButton>Envoyer</FormikSubmitButton>
        <Callout variant="success">{message}</Callout>
      </Form>
    </Formik>
  );
}
